import React from 'react'
import { Box, BoxProps, Center } from '@chakra-ui/react'
import { QRCodeSVG } from 'qrcode.react'
import { ReactComponent as QRCodeBg } from './bg.svg'
import { $color } from '@/utils/cssVarUtils';


interface QRCodeProps extends BoxProps {
  hasFrame?: boolean;
  value: string;
  size?: string | number,
}

function QRCodeFrame() {
  return (
    <Box w="100%" h="100%" position='absolute'>
      <QRCodeBg width='100%' height='100%' />
    </Box>
  )
}

const Component = React.forwardRef((props: QRCodeProps, ref: React.Ref<any>) => {
  const {
    hasFrame, value, size, 
    h, height,
    w, width,
    ...otherProps
  } = props

  const realWidth = w ?? width ?? size ?? '6.25rem'
  const realHeight = h ?? height ?? size ?? '6.25rem'
  const qrCodeSize = hasFrame ? '80%' : '100%'

  return (
    <Box
      ref={ref}
      w={realWidth}
      h={realHeight}
      position='relative'
      { ...otherProps }
    >
      { hasFrame && <QRCodeFrame /> }
      <Center h='100%'>
        <QRCodeSVG
          value={value}
          size={qrCodeSize as any}
          level="M"
          bgColor={$color('bg-normal')}
          fgColor={$color('text-normal')}
        />
      </Center>
    </Box>
  )
})

export {
  Component as QRCode,
  type QRCodeProps, 
}